import { render, staticRenderFns } from "./DeleteCalendario.vue?vue&type=template&id=58b94684&scoped=true"
import script from "./DeleteCalendario.vue?vue&type=script&lang=js"
export * from "./DeleteCalendario.vue?vue&type=script&lang=js"
import style0 from "./DeleteCalendario.vue?vue&type=style&index=0&id=58b94684&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b94684",
  null
  
)

export default component.exports